
import { namespace } from 'vuex-class'
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as sq from '~/store/modules/sq'
import TermsAndConditionsProviderInterface from '~/lib/common/TermsAndConditionsProviderInterface'

const SQ = namespace(sq.name)

@Component({
  components: {
    PlanCard: () => import('~/components/Plans/PlanCard.vue')
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  }
})
export default class PlanSelector extends Vue {
  @Prop({ default: null })
  readonly termsAndConditionsProvider: TermsAndConditionsProviderInterface | null

  @SQ.State
  sq

  @SQ.Getter
  primaryNetwork

  activeType(type: string) {
    return this.primaryNetwork.identifier === type
      ? 'bg-primary text-white'
      : 'bg-grey-light text-grey-dark'
  }

  isLandingPage(): boolean {
    if (this.$route.path.includes('internet/home-wireless-broadband'))
      return true
    return false
  }
}
